<template>
  <v-form ref="form">
    <v-layout>
      <v-text-field
        :value="value"
        :disabled="disabled"
        :rules="[
          $store.state.validationRules.required,
          $store.state.validationRules.trackingNo,
          trackingNoRule
        ]"
        label="運單號碼"
        autofocus
        class="mb-3"
        @input="$emit('input', $event.trim())"
      />
      <v-btn
        v-if="showConfirmButton"
        class="info"
        @click="handleConfirm"
      >
        確認
      </v-btn>
    </v-layout>
  </v-form>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    showConfirmButton: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    trackingNoRule (val) {
      if (this.$store.state.jyWarehouses.find(item => item.mobile === val)) {
        return '這是倉庫電話，非包裹快遞單號，請確認正確的快遞單號並登記'
      }
      if (['0082940036096', '0956940156307'].includes(val)) {
        return '這是巧巧郎的收款銀行帳號，非包裹快遞單號，請確認正確的快遞單號並登記'
      }
      return true
    },
    handleConfirm () {
      if (this.$refs.form.validate()) {
        this.$emit('confirm')
      }
    }
  }
}
</script>
